//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import draggable from "vuedraggable"
import { jsPlumb } from 'jsplumb'
import $ from 'jquery'
import 'jquery-ui-dist/jquery-ui'
import 'jquery-ui-dist/jquery-ui.css'
// const jsPlumb =JsPlumb.jsPlumb
let isMoreChoose=false
let randomStr=Math.random().toString(36).substr(2,4)
export default {
  name: 'MyJsplumb'+randomStr,
  components:{
     draggable
  },
  data: function(){
    return{
      regionId:"region_id"+this.model.pageId+this.randomStr,//画布id
      
      plumbIns: null,
      elementList:[{
        type:'soild',
        index:0,
        name:'节点元素'
      },{
        type:'frame',
        index:1,
        name:'虚线框元素'
      }],//元素数组
      nodeList:[],//节点数组
      frameList:[],//虚线框数组
      relations:[],//关系连线数组
      nodeWidth:120,//初始虚线宽宽度
      nodeHeight:40,//初始虚线宽高度
      isLoad:false,
      isEdit:false,
      gridLength:20,
      randomStr:'',
    }
  },
 
  created: function(){
     console.log('子created--------33')
    this.handleInitData()//调用后台初始化接口
    this.initSize()
    this.randomStr=Math.random().toString(36).substr(2,4);
  },
   destroyed() {
      console.log('子destroyed--------33')
           
        },
   watch:{
      addElement:{
       handler:function(newval,oldval){
         console.log('addElement',this.addElement)
          if(this.addElement.elementType=='node'){
            //将后台id与前端节点id关联起来
            this.nodeList.forEach(element => {
              if(element.clientId==this.randomStr+'_'+this.addElement.clientId){
                  element.id=this.addElement.id
              }
            });
           }else if(this.addElement.elementType=='frame'){
            // 将后台id与前端虚线框id关联起来
              this.frameList.forEach(element => {
              if(element.clientId==this.randomStr+'_'+this.addElement.clientId){
                  element.id=this.addElement.id
              }
              console.log('this.frameList',this.frameList)
            });
           }else if(this.addElement.elementType=='connectLine'){
             //将后台id与前端线id关联起来
                this.relations.forEach(i=>{
                    if(this.randomStr+'_'+i.clientId==this.addElement.clientId){
                           i.id=this.addElement.id
                    }
                })
                console.log('关联后的数组',this.relations)
           }
       },
       deep: true
     },
     isSave:{
       handler:function(newval,oldval){
         console.log('isSave',this.isSave)
           this.saveData()
       },
       deep: true
     },
     initAllData:{
       handler:function(newval,oldval){
         console.log('initAllData',this.initAllData)
          this.isLoad=true
          // this.plumbIns.deleteEveryConnection();
          //  this.plumbIns.deleteEveryEndpoint();
            
           
           this.initData()
       },
       deep: true
     },
     changeElement:{
       handler:function(newval,oldval){
         console.log('changeElement',this.changeElement)
         this.changeNode()
         
       },
       deep: true
     }, 
     destroyed:{
       handler:function(newval,oldval){
         console.log('isSave',this.destroyed)
            if(this.plumbIns&&this.destroyed){
                this.plumbIns.reset()
            }
       },
       deep: true
     },
  },
  props: {
    addElement:Object,
    model: Object,
    getLangMsg: Function,
    invoke: Function,
    changeElement:Object,
    isSave:String,
    initAllData:Object,
    destroyed:Boolean
  },

  mounted: function(){
       console.log('子mounted--------33')
     console.log('this.model.pageId',this.model.pageId,this.randomStr)
     
    
  },
 
  methods:{
    //添加监听
    addWatch(){
      document.onkeydown=(e)=>{    //对整个页面监听  
        if(this.isEdit){
          var keyNum=window.event ? e.keyCode :e.which;       //获取被按下的键值  
    
          //判断如果用户按下了ctrl
          if(e.ctrlKey){  
              console.log('您按下了ctrl');  
              isMoreChoose=true
          } 
          if(e.ctrlKey&&keyNum==65) {
            // alert('全选'); 
            isMoreChoose=true
            this.Allchoose()
            return false;
          }
        }
     }
     document.onkeyup=(e)=>{    //对整个页面监听  
      if(this.isEdit){
        var keyNum=window.event ? e.keyCode :e.which;       //获取被放开的键值  
       if(keyNum==46){  
            // alert('您按下了删除');  
            this.delNodeMore()
        }
         if (e && keyNum == 40) { 
              // alert('下键');
              this.moveKeyup('Bottom')
          }
          if (e && keyNum == 37) {
             this.moveKeyup('Left') 
              // alert('左键');
          }
          if (e && keyNum == 39) { 
              this.moveKeyup('Right') 
              // alert('右键');
          }
          if (e && keyNum == 38) { 
             this.moveKeyup('Top') 
              // alert('上键');
          }
      //判断如果用户放开了ctrl
        if(!e.ctrlKey){  
            console.log('您放开了ctrl');  
            isMoreChoose=false
        }  
     }
     }
    },
    //全选
    Allchoose(){
      
        this.frameList.forEach(i=>{
          i.isChoose=true
        })
        this.nodeList.forEach(i=>{
          i.isChoose=true
        })  
        // 连线红色选中
                  let connections =  this.plumbIns.getAllConnections();
                    for(let n in connections){
                         this.relations.forEach(i=>{
                           i.isChoose=true
                          if(connections[n].endpoints[0]._jsPlumb.uuid==i.sourceNode&&connections[n].endpoints[1]._jsPlumb.uuid==i.targetNode){
                            if(connections[n]._jsPlumb.types.includes("solidLine")||connections[n]._jsPlumb.types.includes("default")){
                              connections[n].setType('solidLineClick')  
                              connections[n].setLabel(i.name)  
                            }
                            if(connections[n]._jsPlumb.types.includes("dottedLine")){
                              connections[n].setType('dottedLineClick')  
                              connections[n].setLabel(i.name)  
                            } 
                          }
                        }) 
                }  
    },
    //键盘监听移动位置
    moveKeyup(direction){
            //改变位置信息
     this.nodeList.forEach(i=>{
         if(i.isChoose){ 
             switch(direction) {
                  case 'Bottom':
                      i.positionY+=this.gridLength
                      break;
                  case 'Top':
                      i.positionY-=this.gridLength
                      break;
                  case 'Left':
                      i.positionX-=this.gridLength
                      break;
                   case 'Right':
                      i.positionX+=this.gridLength
                      break;
                  default:                
              }          
         }
      })
     this.frameList.forEach(i=>{
         if(i.isChoose){
             switch(direction) {
                  case 'Bottom':
                      i.startPositionY+=this.gridLength
                      break;
                  case 'Top':
                      i.startPositionY-=this.gridLength
                      break;
                  case 'Left':
                      i.startPositionX-=this.gridLength
                      break;
                   case 'Right':
                      i.startPositionX+=this.gridLength
                      break;
                  default:                
              }
         }
      })
        // this.plumbIns.repaintEverything()
     this.$nextTick(()=>{
       this.$forceUpdate();
       this.plumbIns.repaintEverything()
     })
    },
    //虚线框文字位置信息
    getPosition(position){
      let style=''
      let top=''
      let left=''
      let bottom=''
      let right=''
      let width=''
       if(position=='down'){
          top='top:auto;'
          bottom='bottom:-24px;'
          width='width: 100%;'
       }else if(position=='left'){
          top='top: 50%;transform: translate(0,-50%);'
          left='left:-24px;'
          right='right:auto;'
          bottom='bottom:auto;'
          width='writing-mode: vertical-lr;'
       }else if(position=='right'){
          top='top: 50%;transform: translate(0,-50%);'
          left='left:auto;'
          right='right:-24px;'
          bottom='bottom:auto;'
          width='writing-mode: vertical-rl;'
       }else{
          top='top:-24px;'
          bottom='bottom:auto;'
          width='width:100%;'
       }
      style=top+left+bottom+right+width
      return style      
    },
    //节点样式
     getNodeStyle(item){
      let style='';
      let left='left:'+item.positionX+'px;'
      let top='top:'+item.positionY+'px;'
      let width='width:'+item.width+'px;'
      let height='height:'+this.nodeHeight+'px;'
      let lineHeight='line-height:'+this.nodeHeight+'px;'
      let background='background:'+item.backgroundColor+';'
      let border='border:1px solid '+item.broaderColor+';'
      let color='color:'+item.textColor+';'
      if(item.isChoose){
        border='border:2px solid  #ff8d00;'
      }
      
      style=left+top+width+height+lineHeight+background+border+color
      return  style;
    },
    //虚线框样式
    getFrameStyle(item){
     let style='';
      let left='left:'+item.startPositionX+'px;'
      let top='top:'+item.startPositionY+'px;'
      let width='width:'+item.width+'px;'
      let height='height:'+item.height+'px;'
      let border=''
      if(item.isChoose){
     
        border='border:2px solid  #ff8d00;'
      }
      // let background='background:'+item.background+';'
      // let border='border:1px solid '+item.border+';'
      // let color='color:'+item.color+';'

      style=left+top+width+height+border
      return  style;
    },
    //初始化尺寸
    initSize(){ 
      // this.nodeHeight=parseInt(window.screen.height*40/900) //根据屏幕大小自定义宽高 32~48
      // if(this.nodeHeight<35){this.nodeHeight=35}
      // if(this.nodeHeight>42){this.nodeHeight=42}
      console.log(' this.nodeHeight',window.screen.height,this.nodeHeight)
      this.nodeWidth=parseInt(1200*110/1366)//根据屏幕大小自定义宽，ui尺寸1366
      console.log(' this.width',window.screen.width,this.nodeWidth)
      if(this.nodeWidth<100){this.nodeWidth=100}
      if(this.nodeWidth>=100&&this.nodeWidth<=100){this.nodeWidth=120}
      if(this.nodeWidth>140){this.nodeWidth=140}
    },
    isInitJsplumb(){
       if(!this.isLoad){
         setTimeout(()=>{
            this.isInitJsplumb()
          },100)
       }else{
           this.initJsplumb();
       }
    },
    //深拷贝
     cloneDeepJson(obj){
         return JSON.parse(JSON.stringify(obj))
      },
    //前端初始化数据
    initData: function(){
      if(this.plumbIns){
          console.log('this.plumbIns存在，清空')
          // this.deleteflowchart(this.nodeList)
          // this.deleteflowchart(this.frameList)
          this.plumbIns.reset()
          this.plumbIns=null
       }
      // console.log('initAllData',this.initAllData)
      let allData=this.cloneDeepJson(this.initAllData)
      this.isEdit=allData.isEdit
      this.regionId="region_id"+allData.UUID+this.isEdit
      this.nodeList=allData.navigationSchemeBean.navigationSchemeNodeEntryBeanList
      this.frameList=allData.navigationSchemeBean.navigatonSchemeFrameEntryBeanList
      this.relations=allData.navigationSchemeBean.navigatonSchemeConnectLineEntryBeanList
      this.nodeList.forEach(i=>{
        this.$set(i,'isChoose',false)
        i.clientId=this.randomStr+'_'+i.clientId
      })
      this.frameList.forEach(i=>{
        this.$set(i,'isChoose',false)
         i.clientId=this.randomStr+'_'+i.clientId
      })
      this.relations.forEach((i)=>{
        this.$set(i,'isChoose',false)
        i.sourceNode=this.randomStr+'_'+i.sourceNode
        i.targetNode=this.randomStr+'_'+i.targetNode
      })
      console.log('初始化this.nodeList',this.nodeList) 
      console.log('初始化this.frameList',this.frameList) 
      console.log('初始化this.relations',this.relations)  
       this.isInitJsplumb(); 
    },
    //删除多个数据
    delNodeMore(){
        console.log('删除前',this.nodeList,this.frameList, this.relations)

            for (let i = this.nodeList.length - 1; i >= 0; i--) {
                 if(this.nodeList[i].isChoose){
                     console.log('删除节点',this.nodeList[i].name)
                     this.delNode(this.nodeList[i].clientId,'node',this.nodeList[i].id)
                   }
            }
            for (let i = this.frameList.length - 1; i >= 0; i--) {
                 if(this.frameList[i].isChoose){
                     console.log('删除节点',this.frameList[i].name)
                     this.delNode(this.frameList[i].clientId,'frame',this.frameList[i].id)
                   }
            }
            for (let num = this.relations.length - 1; num >= 0; num--) {
                 if(this.relations[num].isChoose){
                   console.log('删除线',this.relations[num].name,num)
                   this.handleClickElement('connectLine',this.relations[num].id,'delete')//后台删
                   let connections =  this.plumbIns.getAllConnections();
                    for(let n in connections){
                          if(connections[n].endpoints[0]._jsPlumb.uuid==this.relations[num].sourceNode&&connections[n].endpoints[1]._jsPlumb.uuid==this.relations[num].targetNode){
                             console.log('删除连线',connections[n].endpoints[0]._jsPlumb.uuid)
                             this.plumbIns.deleteConnection(connections[n]);//画布删除连接线

                          }
                    } 
                   this.relations.splice(num,1)//数据删
                }  
            }
             console.log('删除后',this.nodeList,this.frameList, this.relations)
  },
    //创建画布
    initJsplumb: function(){
       console.log(' this.plumbIns', this.plumbIns) 
        // this.plumbIns=null
      if(this.plumbIns){
          this.plumbIns.reset()
      }
      this.plumbIns = jsPlumb.getInstance();
      this.$nextTick(() => {
       
          this.plumbIns.ready(()=>{
             console.log('44')
           
                  this.nodeList.forEach(i=>{
                      this.addOneAnchor(i.clientId)
                  })
                    this.frameList.forEach(i=>{
                      this.addOneAnchor(i.clientId)
                  })
           
             
            let  defaultConfig={
              anchor: ['Left', 'Right', 'Top', 'Bottom', [0.3, 0, 0, -1], [0.7, 0, 0, -1], [0.3, 1, 0, 1], [0.7, 1, 0, 1]],
              connector: ['Flowchart'],
              endpoint: 'Blank',
              // 添加样式
              paintStyle: { stroke: '#CED5E3', strokeWidth:2}, // connector
              hoverPaintStyle: {
                strokeWidth:6,
                stroke: '#ff8d00'
              },
            } 
             this.plumbIns.registerConnectionTypes({
               "solidLine":{
                paintStyle:{stroke:"#CED5E3",strokeWidth:2,dashstyle:'0'}
              },
              "dottedLine":{
                paintStyle:{stroke:"#CED5E3",strokeWidth:2,"dashstyle":"3 2"}
              },
              "solidLineClick":{
                paintStyle:{stroke:'#ff8d00',strokeWidth:2,dashstyle:'0'}
              },
              "dottedLineClick":{
                paintStyle:{stroke:"#ff8d00",strokeWidth:2,"dashstyle":"3 2"}
              }
            });
          //  let setting = {
          //                 paintStyle: {stroke: 'green', strokeWidth: 1},
          //                 connectorStyle: {stroke: 'green', strokeWidth: 1},
          //                 connectorHoverStyle: {stroke: 'green', strokeWidth: 3 },
          //                 hoverPaintStyle: { stroke: 'green', strokeWidth: 3 }
          //               }
          //             // 应用新样式
          //                 jsPlumb.registerConnectionType('custom', setting)
            for (let item of this.relations) {

               this.plumbIns.connect({
                // source: item[0],
                // target: item[1],
                 uuids: [item.sourceNode,item.targetNode],
                 type:item.type,
                 label:item.name,
              }, defaultConfig)
            }
            //连接线回调函数
            this.plumbIns.bind("connection", (info)=>{
                 console.log('connection',info)
                 let item={
                   id:'',
                   clientId:info.connection.id,
                   sourceNode:info.connection.endpoints[0]._jsPlumb.uuid,
                   targetNode:info.connection.endpoints[1]._jsPlumb.uuid,
                   sourceId:info.sourceId,
                   targetId:info.targetId,
                   name:'',
                   type:'solidLine',
                   isChoose:false
                 }
                 this.relations.push(item)
                //  nodeList
                 console.log('relations',this.relations)
                  this.handleAddElement('connectLine',this.randomStr+"_"+info.connection.id,info.connection.endpoints[0]._jsPlumb.uuid,info.connection.endpoints[1]._jsPlumb.uuid)
            });
              this.plumbIns.bind('click', (conn,originalEvent)=>{
                     
                  console.log('单击',conn._jsPlumb.types,conn)
                  if(!this.isEdit){
                      return
                  }
                  if(!isMoreChoose){
                 //清空节点红色选中
                 this.frameList.forEach(i=>{
                      i.isChoose=false
                    })
                  this.nodeList.forEach(i=>{
                      i.isChoose=false
                  })
                 // 清空连线红色选中
                  let connections =  this.plumbIns.getAllConnections();
                    for(let n in connections){
                         this.relations.forEach(i=>{
                          if(connections[n].endpoints[0]._jsPlumb.uuid==i.sourceNode&&connections[n].endpoints[1]._jsPlumb.uuid==i.targetNode){
                            i.isChoose=false
                            if(connections[n]._jsPlumb.types.includes("solidLineClick")){
                              connections[n].setType('solidLine')  
                              connections[n].setLabel(i.name)  
                            }
                            if(connections[n]._jsPlumb.types.includes("dottedLineClick")){
                              connections[n].setType('dottedLine')  
                              connections[n].setLabel(i.name)  
                            } 
                          }
                        }) 
                   }
                }
                // isMoreChoose ctrl一直按着为false，可以多选，
                   this.relations.forEach(i=>{
                    if(conn.endpoints[0]._jsPlumb.uuid==i.sourceNode&&conn.endpoints[1]._jsPlumb.uuid==i.targetNode){
                      console.log('conn._jsPlumb.types',conn._jsPlumb.types)
                      i.isChoose=!i.isChoose
                      if(i.isChoose){
                         console.log('选中')
                          if(conn._jsPlumb.types.includes("dottedLine")){
                            conn.setType('dottedLineClick')  
                            conn.setLabel(i.name)  
                          }
                          if(conn._jsPlumb.types.includes("solidLine")||conn._jsPlumb.types.includes("default")){
                            conn.setType('solidLineClick')  
                            conn.setLabel(i.name)  
                          } 
                      }else{
                        console.log('没选中')
                        if(conn._jsPlumb.types.includes("dottedLineClick")){
                          conn.setType('dottedLine')  
                          conn.setLabel(i.name)  
                        }
                        if(conn._jsPlumb.types.includes("solidLineClick")){
                          conn.setType('solidLine')  
                          conn.setLabel(i.name)  
                        } 
                      }
                      
                      
                       
                       this.handleClickElement('connectLine',i.id,'click')   
                    }
                  })   
            })
          });
          if(this.isEdit){
              this.handleSizeDrag()//虚线框设置可以调整
          }
     });
    },
    //改变位置信息
    changePos(id,ui){
    if(ui.position.left>=0&&ui.position.top>=0){
      console.log('id,ui',id,ui)
      this.nodeList.forEach(i=>{
          if(i.clientId==id){
              i.positionX=ui.position.left;
              i.positionY=ui.position.top;
              i.positionX=this.handlerPosition(ui.position.left,this.gridLength)
              i.positionY=this.handlerPosition(ui.position.top,this.gridLength)
              if(ui.size){
                i.width=ui.size.width; 
              i.width=this.handlerPosition(ui.size.width,this.gridLength*2)           
              }
          }
        })
      }else{
       if(ui.position.left<0){
          this.nodeList.forEach(i=>{
            if(i.clientId==id){
                i.positionX=0;
                i.positionY=ui.position.top;
                i.positionX=this.handlerPosition(0,this.gridLength)
                i.positionY=this.handlerPosition(ui.position.top,this.gridLength)
                if(ui.size){
                  i.width=ui.size.width; 
                i.width=this.handlerPosition(ui.size.width,this.gridLength*2)           
                }
            }
          })
       }
       if(ui.position.top<0){
          this.nodeList.forEach(i=>{
          if(i.clientId==id){
              i.positionX=ui.position.left;
              i.positionY=0;
              i.positionX=this.handlerPosition(ui.position.left,this.gridLength)
              i.positionY=this.handlerPosition(0,this.gridLength)
              if(ui.size){
                i.width=ui.size.width; 
              i.width=this.handlerPosition(ui.size.width,this.gridLength*2)           
              }
          }
        })
       }
       console.log('请拖到合适的位置')
     }
     console.log('this.nodeList',this.nodeList)
     this.$nextTick(()=>{
       this.$forceUpdate();
       this.plumbIns.repaintEverything()
     })
      
    },
    changePosDash(id,ui){
       if(ui.position.left>=0&&ui.position.top>=0){
       console.log('id,ui',id,ui)
     this.frameList.forEach(i=>{
         if(i.clientId==id){
            i.startPositionX=ui.position.left;
            i.startPositionY=ui.position.top;
            i.startPositionX=this.handlerPosition(ui.position.left,this.gridLength)
            i.startPositionY=this.handlerPosition(ui.position.top,this.gridLength)
            if(ui.size){
              i.width=ui.size.width;
               i.height=ui.size.height;
              i.width=this.handlerPosition(ui.size.width,this.gridLength*2)      
              i.height=this.handlerPosition(ui.size.height,this.gridLength*2)      
            }
         }
       })
        // this.plumbIns.repaintEverything()
      }else{
        console.log('请拖到合适的位置')
     }  
     this.$nextTick(()=>{
       this.$forceUpdate();
       this.plumbIns.repaintEverything()
     })
    //  this.$forceUpdate();

       console.log('this.frameList',this.frameList)
      //   this.nodeList.forEach(i=>{
      //    if(i.clientId==id){
      //       i.startPositionX=ui.position.left;
      //       i.startPositionY=ui.position.top;
      //       if(ui.size){
      //         i.width=ui.size.width;
      //         i.height=ui.size.height;
      //       }
      //    }
      //  })
      
    },
    //节点\虚线框和线的信息改变
    changeNode(){
         if(this.changeElement.elementType=='node'){
            //改变了节点node
            this.nodeList.forEach(element => {
              if(element.id==this.changeElement.value.id){
                  element.name=this.changeElement.value.name
                  element.backgroundColor=this.changeElement.value.backgroundColor
                  element.broaderColor=this.changeElement.value.broaderColor
                  element.textColor=this.changeElement.value.textColor

              }
            });
            console.log(' this.nodeList', this.nodeList)
            //改变了虚线框
           }else if(this.changeElement.elementType=='frame'){
              this.frameList.forEach(element => {
              if(element.id==this.changeElement.value.id){
                    element.name=this.changeElement.value.name
                    element.namePosition=this.changeElement.value.namePosition
               }
            });
           }else if(this.changeElement.elementType=='connectLine'){
                     let connections = this.plumbIns.getAllConnections();
                         for(let i in connections){   
                          //  console.log('con线',connections[i].id,this.changeElement.value.clientId,connections[i],connections[i].endpoints[0]._jsPlumb.uuid,this.changeElement.value.sourceNode,connections[i].endpoints[1]._jsPlumb.uuid,this.changeElement.value.targetNode)
                           if(connections[i].endpoints[0]._jsPlumb.uuid==(this.randomStr+'_'+this.changeElement.value.sourceNode)&&connections[i].endpoints[1]._jsPlumb.uuid==(this.randomStr+'_'+this.changeElement.value.targetNode)){//找到对应线
                            
                              if(this.changeElement.opType=='refresh'){//更新模型
                                let showType;//显示类型
                                 if(this.changeElement.value.type=='solidLine'){
                                    showType='solidLineClick'
                                 }
                                 if(this.changeElement.value.type=='dottedLine'){
                                    showType='dottedLineClick'
                                 }
                                 connections[i].setType(showType);
                                 connections[i].setLabel(this.changeElement.value.name)
                                 this.relations.forEach(element=>{//更新数组
                                  if(element.id==this.changeElement.value.id){
                                      element.name=this.changeElement.value.name
                                      element.type=this.changeElement.value.type
                                  }
                                })
                               }else if(this.changeElement.opType=='delete'){//删除
                                  this.plumbIns.deleteConnection(connections[i])//删除模型
                                  this.relations.splice(this.relations.findIndex(item=>item.id==this.changeElement.value.id),1)//删除数组
                                  console.log('this.relations',this.relations)
                               }                               
                           }           
                       }
           }
    },
    //删除节点信息
    delNode(clientId,type,id){
      console.log('删除',clientId,type)
      if(type=='frame'){
          this.frameList.splice(this.frameList.findIndex(item=>item.clientId==clientId),1)
          this.plumbIns.removeAllEndpoints(clientId);
          let newArr = this.relations.reduce((total, current) => {
            // 只push符合条件的
            (!current.sourceNode.includes(clientId)&&!current.targetNode.includes(clientId)) && total.push(current);
              return total;
          }, []);
          console.log("newArr",newArr)
          this.relations=newArr
          this.handleClickElement('frame',id,'delete')
      }else if(type=='node'){ 
        this.nodeList.splice(this.nodeList.findIndex(item=>item.clientId==clientId),1)
        this.plumbIns.removeAllEndpoints(clientId);
        let newArr = this.relations.reduce((total, current) => {
          // 只push符合条件的
          (!current.sourceNode.includes(clientId)&&!current.targetNode.includes(clientId)) && total.push(current);
            return total;
        }, []);
        console.log("newArr",newArr)
        this.relations=newArr
         this.handleClickElement('node',id,'delete')
      }
    },
    //虚线框处理
    handleSizeDrag: function(idStr){
   
           let that=this
                 setTimeout(function () {
                 $('.mjRight-items_node').resizable({
                  //  containment:'#'+that.regionId,
                         handles: 'e',
                         grid:20,
                         edge:20,
                         resize(el,ui){//拖拽结束后的回调
                            console.log('拖拽结束: ',el.target.id);
                            console.log('this',el,ui);
                            that.changePos(el.target.id,ui)
                           
                        }
                        // stop(el,ui){//拖拽结束后的回调
                        //     console.log('拖拽结束: ',el.target.id);
                        //     console.log('this',el,ui);
                        //     that.changePos(el.target.id,ui)
                           
                        // }
                   })
                  //  let revert=true
                   $('.mjRight-items_node').draggable({
                      //  containment:'#'+that.regionId,
                        grid: [20, 20],
                        snap:true,
                        // revert:revert,
                        drag(el,ui){//拖拽结束后的回调
                            console.log('拖拽结束2: ',el.target.id);
                            console.log('this',el,ui.position);
                            that.changePos(el.target.id,ui)
                            //  that.plumbIns.repaintEverything()
                            
                        }
                    })
                   $('.mjRight-items_frame').resizable({
                        // containment:'#'+that.regionId,
                         handles:'s, e',
                         grid:20,
                          edge:20,
                        resize(el,ui){//拖拽结束后的回调
                            console.log('拖拽结束: ',el.target.id);
                            console.log('this',el,ui);
                             that.changePosDash(el.target.id,ui)
                              // that.plumbIns.repaintEverything()
                        }
                   })
                    $('.mjRight-items_frame').draggable({
                      // containment:'#'+that.regionId,
                       grid: [20, 20],
                         snap:true,
                        drag(el,ui){//拖拽结束后的回调
                            console.log('拖拽结束2: ',el.target.id);
                            console.log('this',el,ui.position);
                             that.changePosDash(el.target.id,ui)
                            //  that.plumbIns.repaintEverything()
                            
                        }
                    })
                  }, 100);
    },
    //节点处理，添加描点
    addOneAnchor: function(idStr){
     
      let defaultConfigAnchor={
        isSource: true,
        isTarget: true,
        maxConnections: -1,
        // Set the type of endpoint
        endpoint: 'Dot',
 
        // Set the style of anchor
        paintStyle: {
          fill: 'pink',
          radius:6,
         
        }, 
       endpointClass:'endpointClass',
       cssClass:'endpointClass',
        // paintStyle: { stroke: '#909399', strokeWidth: 2 },
        // hoverPaintStyle: {
        //   strokeWidth: 2,
        //   stroke: 'lightblue'
        // },
 
        // Set connection line
        connector: 'Flowchart',
        // The following styles apply only to type flowchart
        // connector: ['Flowchart', {gap: 10, cornerRadius: 5, alwaysRespectStubs: true}],
       
       // Set the style of line
        connectorStyle:{
          strokeWidth: 2,
          stroke: '#CED5E3',
       },
         
       
        connectorHoverStyle: {
          strokeWidth: 6,
          stroke: '#ff8d00'     
        },
        // Set the style of arrow
         connectorOverlays: [ 
         ['Arrow', { width: 8, length: 8, location: 1 }], 

          ],
      };
        if(!this.isEdit){
          // console.log('隐藏端点')
           defaultConfigAnchor.endpoint='Blank'
         }
           if(!this.isEdit){
            defaultConfigAnchor.connectorHoverStyle.strokeWidth=0
            defaultConfigAnchor.connectorHoverStyle.stroke='#CED5E3'
          }
           
      // console.log('idStr',idStr)
      this.plumbIns.addEndpoint(idStr, {anchor: 'Top',uuid:idStr+'-Top'},defaultConfigAnchor);
      this.plumbIns.addEndpoint(idStr, {anchor: 'Right',uuid:idStr+'-Right'}, defaultConfigAnchor);
      this.plumbIns.addEndpoint(idStr, {anchor: 'Bottom',uuid:idStr+'-Bottom'}, defaultConfigAnchor);
      this.plumbIns.addEndpoint(idStr, {anchor: 'Left',uuid:idStr+'-Left'}, defaultConfigAnchor);
      let that=this
      // Set drag and the region
      // this.plumbIns.draggable(idStr,
      // {
      //   containment: this.regionId,
      //   grid: [20, 20],
      //   stop(el){//拖拽结束后的回调
      //         console.log('节点拖拽结束:', el);
      //         // that.changePos(el)
      //     }
      //  });
     
    },
    handlerPosition(x, n){
        return parseInt(x/n + 0.5) * n;
    },
    //拖拽结束。添加虚线框和节点
    dragWidget: function(event){
      console.log('拖动',event.item, event.item.innerText,event.item.id)
      // Get position of widget
      var widgetX = event.originalEvent.clientX;
      let widgetY = event.originalEvent.clientY;
      
      var regionRect = this.$refs[this.regionId].getBoundingClientRect();
      
      // Judge the widget in the region&& widgetX<regionRect.left+regionRect.width && widgetY<regionRect.top+regionRect.height
      if(widgetX>regionRect.left && widgetY>regionRect.top ){
        // Set the parameter 
        let left = widgetX - regionRect.left;
        let top = widgetY - regionRect.top;
        console.log('left',left,'top',top)
        left=this.handlerPosition(left,this.gridLength)
        top=this.handlerPosition(top,this.gridLength)
       if(event.item.id=='frame'){
         let curConId ="f"+new Date().getTime();
          let curConIds=this.randomStr+"_"+curConId
          this.frameList.push({
            id:'',
            clientId:curConIds,
            name: event.item.innerText,
            startPositionY:top,
            startPositionX:left,
             width:this.nodeWidth,
             height:this.nodeHeight,
             namePosition:'top',
             isChoose:false,
             
          });
          this.$set(this.frameList[this.frameList.length-1],'isChoose',false)
           console.log('this.frameList',this.frameList)
          // After delaying DOM updates
           this.$nextTick(()=>{
               this.addOneAnchor(curConIds);
               
               this.handleSizeDrag()
               this.plumbIns.repaintEverything()
           });
           this.handleAddElement('frame',curConId)
       }else if(event.item.id=='soild'){
          let curnodeConId ="n"+new Date().getTime();
          let curnodeConIds=this.randomStr+"_"+curnodeConId

          this.nodeList.push({
            id:'',
            clientId:curnodeConIds,
            name: event.item.innerText,
            positionY:top,
            positionX:left,
             width:this.nodeWidth,
            isChoose:false,
            backgroundColor:'#E8EEFF',
            broaderColor:'#C8D2F3',
            textColor:'#0F4BD2'
          }); 
          
           this.$set(this.nodeList[this.nodeList.length-1],'isChoose',false)
            console.log('this.nodeList',this.nodeList.length,this.nodeList)
         
          // After delaying DOM updates
           this.$nextTick(()=>{
               this.addOneAnchor(curnodeConIds);
                // this.nodeList.forEach(i=>{
                //   this.$set(i,'isChoose',false)
                //   i.clientId=this.randomStr+'_'+i.clientId
                // })
               this.handleSizeDrag()
               this.plumbIns.repaintEverything()
           });
             this.handleAddElement('node',curnodeConId)
          
       }      
      }else{
        // alert("请拖拽到内容框中");
         let value={
                      msg:'请拖拽到内容框中',
                      type:'error'
                    }
                  let parm={content:{ type:'show_info', value:value}}
                 console.log('传给后台的参数',parm)
                 this.invoke('invokeCustomEvent',parm) 
                 return
      }
    },
     //调用后台初始化接口
    handleInitData: function () {
      console.log('初始化数据')
      this.invoke('invokeCustomEvent',{content:{ type: 'navigationmap_init_data', value:''}})
   },
    //调用后台添加元素接口
    handleAddElement: function (elementType,clientId,sourceNode='',targetNode='',) {
          let value={}
          if(elementType=='connectLine'){
            value={
                elementType:elementType,
                clientId:clientId,
                sourceNode:sourceNode.substring(5),
                targetNode:targetNode.substring(5),
            }
          }else{
              value={
                  elementType:elementType,
                  clientId:clientId,
              }
          }
          let parm={content:{ type:'navigationmap_new_element', value:value}}
          console.log('传给后台的参数',parm)
          this.invoke('invokeCustomEvent',parm) 
    },
      handleClickElements: function (elementType,id,opType,num) {
        console.log('是否多选',isMoreChoose)
       if(!isMoreChoose){
         console.log('清空其他')
         this.frameList.forEach(i=>{
            i.isChoose=false
          })
        this.nodeList.forEach(i=>{
            i.isChoose=false
          })
         // 清空连线红色选中
                  let connections =  this.plumbIns.getAllConnections();
                    for(let n in connections){
                         this.relations.forEach(i=>{
                           i.isChoose=false
                          if(connections[n].endpoints[0]._jsPlumb.uuid==i.sourceNode&&connections[n].endpoints[1]._jsPlumb.uuid==i.targetNode){
                            if(connections[n]._jsPlumb.types.includes("solidLineClick")){
                              connections[n].setType('solidLine')  
                              connections[n].setLabel(i.name)  
                            }
                            if(connections[n]._jsPlumb.types.includes("dottedLineClick")){
                              connections[n].setType('dottedLine')  
                              connections[n].setLabel(i.name)  
                            } 
                          }
                        }) 
                }  
        }     
        if(elementType=='frame'){
          // if(!isMoreChoose){
            this.frameList[num].isChoose=!this.frameList[num].isChoose
          // }else{
          //   this.frameList[num].isChoose=!this.frameList[num].isChoose
          // }
        }
        if(elementType=='node'){ 
        //  if(!isMoreChoose){
            this.nodeList[num].isChoose=!this.nodeList[num].isChoose
        //   }else{
        //     this.nodeList[num].isChoose=!this.nodeList[num].isChoose
        //   }
        }
        console.log('node',elementType,this.nodeList)
        this.handleClickElement(elementType,id,opType)
      },
      //调用后台点击元素接口
      handleClickElement: function (elementType,id,opType) {
        
          let value={
              elementType:elementType,
              id:id,
              opType:opType
          }
          let parm={content:{ type:'navigationmap_client_op_element', value:value}}
          console.log('传给后台的参数',parm)
          this.invoke('invokeCustomEvent',parm) 
    },
      //调用后台保存接口
      saveData:function(){
      let relations=this.cloneDeepJson(this.relations)
      relations.forEach(i=>{
        i.sourceNode=i.sourceNode.substring(5)
        i.targetNode=i.targetNode.substring(5)
      })
       let nodeList=this.cloneDeepJson(this.nodeList)
      nodeList.forEach(i=>{
        i.clientId=i.clientId.substring(5)
      })
       let frameList=this.cloneDeepJson(this.frameList)
      frameList.forEach(i=>{
       i.clientId=i.clientId.substring(5)
      }) 
      let value={
              navigationSchemeNodeEntryBeanList:nodeList,
              navigatonSchemeConnectLineEntryBeanList:relations,
              navigatonSchemeFrameEntryBeanList:frameList
          }
          let parm={content:{ type:'navigationmap_save_data', value:value}}
          console.log('传给后台的参数',parm)
          this.invoke('invokeCustomEvent',parm) 
    },
  }
}
